import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Packages from '../components/sections/Packages';
import About from '../components/sections/About';
import Destination from '../components/sections/Destination';
import Testimonials from '../components/sections/Testimonials';
import VideoSection from '../components/sections/VideoSection';
import Season from '../components/sections/Season';
import Contact from '../components/sections/Contact';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Golf4Life | Longstay golfrejser til Spanien for pensionister</title>
        <meta name="description" content="Longstay golfophold i Cádiz og Costa de la Luz med lejlighed, fri golf, socialt fællesskab og personlig hjælp fra start til slut." />
      </Helmet>

      <Navbar />
      
      <main>
        <Hero />
        <Packages />
        <About />
        <Destination />
        <Testimonials />
        <VideoSection />
        <Season />
        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default Home;
